"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = __importDefault(require("../../"));
/**
 * Retrieves the authenticated user's account profile information.
 */
class Identity extends __1.default {
    get basePath() {
        return '/commerce/identity/v1';
    }
    get subdomain() {
        return 'apiz';
    }
    /**
     * This method retrieves the account profile information for an authenticated user, which requires a User access
     * token. What is returned is controlled by the scopes.
     */
    getUser() {
        return this.get(`/user/`);
    }
}
exports.default = Identity;
Identity.id = 'Identity';
//# sourceMappingURL=index.js.map